import moment from 'moment';
import { useState } from 'react';
import TableCompHead from '../../../../../components/ui/TableCompHead';
import DatePickerMui from '../../../../../components/common/DatePickerMui';
import formatDate from '../../../../../components/common/formatDate';
import { Grid } from '@mui/material';
import {
  AddIconButton,
  RemoveIconButton,
} from '../../../../../components/common/button/CustomIconButton';
import { TableInput } from '../../../../../components/common';

interface IProps {
  moduleData: any;
  isView: boolean;
  setIsOpenPopup: any;
}

const theadData = [
  'Sr. No.',
  'Date',
  'Process Name / No',
  'Sub Process Name.',
  'Machine No.',
  'Start Time',
  'End Time',
  'Opertaor Name / Code',
  'Plan Qty.',
  'Prod. Qty ',
  'Accepted Qty',
  'B/D Time',
  'Rej. Qty.',
  'Reason For Rejection',
  'Reason For Less Production',
  'Remarks',
  'Delete',
];

const THead = ({ moduleData, isView, setIsOpenPopup }: IProps) => {
  const [render, setRender] = useState(false);
  return (
    <thead>
      <TableCompHead
        colSpan={17}
        rowSpan={3}
        labels={['Doc No', 'Rev', 'Dated']}
        values={['FM-PRD -02', '01', '07/10/2023']}
        heading="Daily Production Record"
      />
      <tr>
        <th colSpan={3}>
          Daily Production Date :
          {isView ? (
            formatDate(moduleData.dailyProduction_date)
          ) : (
            <DatePickerMui
              label=""
              value={moment(moduleData.dailyProduction_date)}
              onChange={(date) => {
                moduleData.dailyProduction_date = date;
                setRender((prev) => !prev);
              }}
            />
          )}
        </th>
        <th
          colSpan={3}
          align="left"
          style={{ width: '250px', minWidth: '250px' }}
        >
          Part Name/No. :
          {isView ? (
            moduleData?.part_id?.part_name +
            '-' +
            moduleData?.part_id?.part_number
          ) : (
            <Grid container xs={12} direction="row" alignItems={'center'}>
              <Grid item xs={10}>
                <p
                  style={{
                    fontSize: '1.6rem',
                  }}
                >
                  {typeof moduleData?.part_id === 'object' &&
                  moduleData?.part_id !== null
                    ? moduleData?.part_id?.part_name +
                      '-' +
                      moduleData?.part_id?.part_number
                    : moduleData?.partName === undefined ||
                        moduleData?.partName === null
                      ? ''
                      : moduleData?.partName + '-' + moduleData?.partNumber ||
                        ''}
                  {!moduleData?.part_id && 'Pick Part Name'}
                </p>
              </Grid>

              {moduleData.part_id ? (
                <Grid item xs={2}>
                  <RemoveIconButton
                    tooltipTitle="remove part"
                    onClick={() => {
                      moduleData.part_id = null;
                      moduleData.partNumber = null;
                      moduleData.partName = null;
                      setRender((prev) => !prev);
                    }}
                  />
                </Grid>
              ) : (
                <Grid item xs={2}>
                  <AddIconButton
                    tooltipTitle="add part"
                    onClick={() => {
                      setIsOpenPopup(true);
                    }}
                  />
                </Grid>
              )}
            </Grid>
          )}
        </th>
        <th colSpan={3} align="left">
          Assy Line :
          <TableInput
            isView={isView}
            name="assy_line"
            type="text"
            value={moduleData.assy_line}
            onChange={(e) => {
              moduleData.assy_line = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </th>
        <th colSpan={4} align="left">
          Prod. I/C:
          <TableInput
            isView={isView}
            name="line_leader"
            type="text"
            value={moduleData.line_leader}
            onChange={(e) => {
              moduleData.line_leader = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </th>
        <th colSpan={3} align="left">
          Job Card No :
          <TableInput
            isView={isView}
            name="job_card_no"
            type="text"
            value={moduleData.job_card_no}
            onChange={(e) => {
              moduleData.job_card_no = e.target.value;
              setRender((prev) => !prev);
            }}
          />
        </th>
      </tr>
      <tr
        style={{
          position: 'sticky',
          width: '100%',
          top: '3.5rem',
          border: '1px solid black',
          zIndex: '1',
          backgroundColor: 'rgb(79, 129, 189)',
          color: '#fff',
        }}
      >
        {theadData.map((heading, index) => (
          <th
            key={heading + index}
            colSpan={heading === 'Remarks' && isView ? 2 : 1}
          >
            {heading === 'Delete' && isView ? '' : heading}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default THead;
